import React, { useState, useCallback } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { THEME_META } from '../../theme/themes';
import ThemeSelectorModal from '../theme/ThemeSelectorModal';
import './DashboardThemeSwitcher.css';

/**
 * DashboardThemeSwitcher — labeled theme pill.
 * Horizontal pill with "Theme" label + segmented color bar.
 * Opens ThemeSelectorModal on click.
 */
export default function DashboardThemeSwitcher() {
  const { currentTheme } = useTheme();
  const [open, setOpen] = useState(false);

  const meta = THEME_META[currentTheme];
  const displayName = meta?.displayName || currentTheme;

  // swatches: [background, cardBg, primary, accent, buttonBg, text]
  const segments = meta?.swatches
    ? [meta.swatches[2], meta.swatches[3], meta.swatches[4]]
    : [];

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  // Build a smooth left-to-right gradient from theme colors
  const gradientBg = segments.length
    ? `linear-gradient(to right, ${segments[0]} 0%, ${segments[1]} 50%, ${segments[2]} 100%)`
    : undefined;

  return (
    <>
      <button
        type="button"
        className="theme-pill"
        onClick={handleOpen}
        aria-label={`Current theme: ${displayName}. Click to change theme.`}
        title="Change theme"
      >
        <span className="theme-pill__label">Theme</span>
        <span className="theme-pill__bar" style={{ background: gradientBg }} />
      </button>

      <ThemeSelectorModal open={open} onClose={handleClose} />
    </>
  );
}
